import React from "react";
import { connect } from "react-redux";
import { RewardETCContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import moment from "moment";
import {
  ExchangeRewardInputStep1,
  ExchangeRewardStep2,
  ExchangeShippingStep,
} from "../Steps";
import { userService } from "apiServices";
import { IMG_PATH } from "utils/constants/imgPath";
import { toast } from "react-toastify";
import { setReduxWallet } from "store/reducers/walletReducer";
import { Cards, Displays, Icons, Modals } from "components";

class RewardETCContainer extends React.Component {
  _isSubmitting = false;

  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let res = await userService.GET_REWARD_LIST(
      `?pagination=false&is_active=true&type=3&sort=sequence`
    );
    if (res && res.status === 200) {
      this.setState({
        isLoading: false,
        data: res.data,
      });
    }
  };

  handleCloseModal = () => {
    this._isSubmitting = false;
    this.setState({
      isShowModal: false,
    });
  };

  handleRenderModal = (key, e) => {
    const { authenRedux } = this.props;
    const { dataSelected, amountSelected } = this.state;
    this._isSubmitting = false;
    switch (key) {
      case "step1":
        this.setState({
          isShowModal: true,
          dataSelected: e,
          renderModal: (
            <ExchangeRewardInputStep1
              data={e}
              onCancel={this.handleCloseModal}
              onAccept={(f) => {
                this.handleRenderModal("step2", f);
              }}
            />
          ),
        });
        break;
      case "step2":
        this.setState({
          isShowModal: true,
          amountSelected: e,
          renderModal: (
            <ExchangeRewardStep2
              data={dataSelected}
              amount={e}
              onCancel={() => this.handleRenderModal("step1", dataSelected)}
              onAccept={async () => {
                if (this._isSubmitting) return;
                this._isSubmitting = true;
                this.setState({
                  isBgLoading: true,
                });
                let params = {
                  reward_id: dataSelected._id,
                  redeem_amount: e,
                  is_request_verify: true,
                };
                let res = await userService.POST_REDEEM_REWARD(params);
                if (res && res.status === 200) {
                  this._isSubmitting = false;
                  this.handleRenderModal("step3");
                } else {
                  this._isSubmitting = false;
                  this.setState({
                    renderModal: (
                      <Cards.MusumiStatus
                        title={"ขออภัย!"}
                        description={
                          "คะแนนของคุณไม่เพียงพอต่อการแลกของรางวัลชิ้นนี้"
                        }
                        btnLabel="ย้อนกลับ"
                        onClick={() => {
                          this.setState({
                            isShowModal: false,
                          });
                        }}
                      />
                    ),
                    isBgLoading: false,
                  });
                }
              }}
            />
          ),
        });
        break;
      case "step3":
        this.setState({
          isShowModal: true,
          isBgLoading: false,
          renderModal: (
            <ExchangeShippingStep
              data={dataSelected}
              customerProfile={authenRedux}
              onCancel={this.handleCloseModal}
              onSubmit={async (values) => {
                if (this._isSubmitting) return;
                this._isSubmitting = true;
                this.setState({
                  isBgLoading: true,
                });
                let params = {
                  ...values,
                  reward_id: dataSelected._id,
                  redeem_amount: amountSelected,
                };
                let res = await userService.POST_REDEEM_REWARD(params);
                if (res && res.status === 200) {
                  let resWallet = await userService.GET_MY_WALLET();
                  if (resWallet && resWallet.status === 200) {
                    this.props.setReduxWallet(resWallet.data);
                    this._isSubmitting = false;
                    this.handleRenderModal("step4");
                  } else {
                    this._isSubmitting = false;
                    this.setState({ isBgLoading: false });
                    toast.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
                  }
                } else {
                  this._isSubmitting = false;
                  this.setState({
                    isBgLoading: false,
                  });
                  toast.error("ไม่สามารถแลกได้ กรุณาเช็คเงื่อนไงในการแลก");
                }
              }}
            />
          ),
        });
        break;
      case "step4":
        this.setState({
          isShowModal: true,
          isBgLoading: false,
          renderModal: (
            <Cards.ProcessStatus
              theme_standard
              icon={<Icons.Success />}
              title={"สำเร็จ"}
              description={
                <>
                  <div>เพิ่มที่อยู่ในการจัดส่งของรางวัลเรียบร้อย</div>
                  <div>ของรางวัลจะถูกส่งออกภายใน 10-15 วันทำการ</div>
                </>
              }
              btnLabel="ตกลง"
              onClick={() => {
                this.props.router.navigate(ROUTE_PATH.ACTIVITY);
              }}
            />
          ),
        });
        break;
      default:
        break;
    }
  };

  render() {
    const { isBgLoading, isShowModal, renderModal, isLoading, data } =
      this.state;
    return (
      <RewardETCContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading />
        ) : (
          <div className="reward_layout">
            {data?.docs &&
              data.docs.map((e, i) => (
                <div
                  key={i}
                  className="reward_wrap"
                  onClick={() => this.handleRenderModal("step1", e)}
                >
                  <Cards.Reward
                    img={IMG_PATH + e.img_path}
                    point={e.redeem_point}
                    amount={e.total_amount - e.redeem_amount}
                    expire={moment(e.expired_at).format("DD/MM/YY")}
                  />
                </div>
              ))}
          </div>
        )}
        <Modals.BodyEmpty
          isShowModal={isShowModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </RewardETCContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxWallet: (data) => dispatch(setReduxWallet(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RewardETCContainer));
